import { render } from "./TalentPool.vue?vue&type=template&id=472906b9"
import script from "./TalentPool.vue?vue&type=script&lang=js"
export * from "./TalentPool.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__